import {AfterViewInit, Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CommonService} from 'src/app/services/common.service';
import {LocalStorageService} from 'src/app/services/local-storage.service';
import {ToastMessagesService} from 'src/app/services/toast-messages.service';
import {AnnouncementsService} from '../../../../services/announcements.service';
import {ConsentsFormService} from '../../../../services/consents-form.service';
import {NotificationService} from '../../../../services/notification.service';

@Component({
    selector: 'app-mobile-search',
    templateUrl: './mobile-search.component.html',
    styleUrls: ['./mobile-search.component.scss']
})
export class MobileSearchComponent implements OnInit, AfterViewInit {
    announcements: any[] = [];
    children: any[] = [];
    currentUser: any;
    loading: boolean;
    pendingAffirmations: any[] = [];
    pendingConsents: any[] = [];
    searchValue: string;
    notifications: any[] = [];
    rowWidth: number;

    constructor(private commonService: CommonService,
                private localStorageService: LocalStorageService,
                public toastMessagesService: ToastMessagesService,
                private announcementsService: AnnouncementsService,
                public router: Router, private notificationService: NotificationService,
                public consentsFormService: ConsentsFormService) {
        this.searchValue = '';
        this.loading = true;
        this.currentUser = JSON.parse(this.localStorageService.get('user'));
        this.rowWidth = window.innerWidth;
    }

    ngOnInit(): void {
    }

    async ngAfterViewInit() {
        try {
            await this.initNotifications(false);
            await this.initAnnouncements(false);
            await this.initializeChildren();
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e);
        }
    }

    async initAnnouncements(force: boolean) {
        try {
            await this.announcementsService.getAllAnnouncements(+this.currentUser.id, force);

            this.announcements = this.announcementsService.announcements;

            for (const announcement of this.announcements) {
                if (announcement.is_opened === 0) {
                    announcement.doShow = true;
                }
            }
        } catch (e) {
            throw e.message;
        } finally {
            this.loading = false;
        }
    }

    async initNotifications(force: boolean) {
        try {
            await this.notificationService.getAllNotifications(+this.currentUser.id, force);

            this.notifications = this.notificationService.getInCompleteNotifications();
        } catch (e) {
            throw e.message;
        } finally {
            this.loading = false;
        }
    }

    async initializeChildren() {
        try {
            const childrenRequest = await this.commonService.getList(`children?parentId=${this.currentUser.id}`);
            this.children = childrenRequest.object;
            let extraInfo;
            const hasExternalClasses = localStorage.getItem('externalClasses');
            if (hasExternalClasses) {
                const extraInfoRequest = await this.commonService.getList(`children/external?parentId=${this.currentUser.id}`);
                extraInfo = extraInfoRequest.object;
            }
            for (const child of this.children) {
                child.notifications = [];
                child.affirmations = [];
                child.announcements = [];
                if (extraInfo && extraInfo.length > 0) {
                    const currentChild = extraInfo.find(c => c.id === child.id);
                    if (currentChild) {
                        child.SchoolUnit = currentChild.SchoolUnit;
                        child.SchoolLevel = currentChild.SchoolLevel;
                        child.Class = currentChild.Class;
                        child.Class_Short = currentChild.Class_Short;
                    }
                }

                for (const announcement of this.announcements) {
                    if (announcement.child_id === child.id) {
                        child.announcements.push(announcement);
                    }
                }

                this.pendingConsents = this.notifications.filter(notification => notification.form_type_id === 1);
                this.pendingAffirmations = this.notifications.filter(notification => notification.form_type_id === 2);
                const filteredConsents = this.notifications.filter(notification => notification.childId === child.id);
                for (const consent of filteredConsents) {
                    const notificationModel = {
                        id: consent.id,
                        formId: consent.formId,
                        unique_id: consent.unique_id,
                        description: consent.description,
                        title: consent.formTitle,
                        subTitle: consent.deadline ? consent.deadline : '-',
                        deadline: consent.deadline ? consent.deadline : '-',
                        content: 'Ενημέρωση και συγκατάθεση ως προς τη συλλογή και επεξεργασία προσωπικών στοιχείων του παιδιού μου',
                        mode: consent.mode
                    };
                    child.notifications.push(notificationModel);
                }
            }
        } catch (e) {
            throw e.message;
        } finally {
            console.log(this.announcements);
            this.loading = false;
        }
    }

    search(value?: string) {
        try {
            this.loading = true;
            if (value && (value === 'consents' || value === 'affirmations' || value === 'announcements')) {
                this.initAll(true);
            } else {
                this.initAll(false, value);
            }
        } catch (e) {
            this.toastMessagesService.toastErrorMessage(e.message);
        } finally {
            this.loading = false;
        }
    }

    initAll(init, value?) {
        if (init) {
            this.pendingConsents = this.notifications.filter(notification => notification.form_type_id === 1);
            this.pendingAffirmations = this.notifications.filter(notification => notification.form_type_id === 2);
            this.announcements = this.announcementsService.announcements;
        } else {
            if (value) {
                console.log(value);
                const titleConsents = this.notifications.filter(notification =>
                    notification.form_type_id === 1 && notification.formTitle.toLowerCase().includes(value.toLowerCase()));
                const titleAffirmations = this.notifications.filter(notification =>
                    notification.form_type_id === 2 && notification.formTitle.toLowerCase().includes(value.toLowerCase()));
                const descriptionAnnouncements = this.announcementsService.announcements.filter(announcement =>
                    announcement.description.toLowerCase().includes(value.toLowerCase()));

                const childConsents = this.notifications.filter(notification =>
                    notification.form_type_id === 1 && notification.displayName.toLowerCase().includes(value.toLowerCase()));
                const childAffirmations = this.notifications.filter(notification =>
                    notification.form_type_id === 2 && notification.displayName.toLowerCase().includes(value.toLowerCase()));
                const childAnnouncements = this.announcementsService.announcements.filter(announcement => announcement.child_first_name.toLowerCase().includes(value.toLowerCase()) || announcement.child_last_name.toLowerCase().includes(value.toLowerCase()));

                this.pendingConsents = titleConsents.concat(childConsents);
                this.pendingAffirmations = titleAffirmations.concat(childAffirmations);
                this.announcements = descriptionAnnouncements.concat(childAnnouncements);
            } else {
                this.pendingConsents = this.notifications.filter(notification => notification.form_type_id === 1);
                this.pendingAffirmations = this.notifications.filter(notification => notification.form_type_id === 2);
                this.announcements = this.announcementsService.announcements;
            }
        }
    }

    async showChildConsent(form: any) {
        const inputConfig = {
            parentId: this.currentUser.id,
            childId: form.childId,
            mode: false,
            unique_id: form.unique_id,
            notificationId: form.id
        };
        await this.router.navigate(['/home/requestFrom'], {queryParams: inputConfig});
    }
}
